import  createTheme  from "@material-ui/core/styles/createTheme"

export const theme = createTheme({
  palette: {
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#ffcf10",
    },
  },
})
